import { LINE_CLAMP } from '../tokens';

// Rounds and bounds a document's `lines` value into one of the static clamp classes
export function lineClampClass(lines: number): string {
  const clamped = Math.min(Math.max(Math.round(lines), 1), LINE_CLAMP.length);
  return LINE_CLAMP[clamped - 1];
}
